<template>
  <div class="ShareItems">

    <a class="ShareItems-item"
      :href="facebookUrl"
      @click.prevent="open('facebook')">

      <icon class="ShareItem-icon"
        name="facebook" />
    </a>

<!--    <a class="ShareItems-item"
      :href="twitterUrl"
      @click.prevent="open('twitter')">

      <icon class="ShareItem-icon"
        name="twitter" />
    </a>-->

    <a class="ShareItems-item"
      v-if="data.vimeoId"
      :href="vimeoUrl"
      target="_blank"
      @click="open">

      <icon class="ShareItem-icon"
        name="vimeo" />
    </a>

    <a class="ShareItems-item"
      :href="emailUrl"
      @click="open">

      <icon class="ShareItem-icon"
        name="email" />
    </a>

    <a class="ShareItems-item"
      v-if="data.vimeoId && !window.supportsTouch"
      :href="vimeoEmbedUrl"
      target="_blank"
      @click="open">

      <icon class="ShareItem-icon"
        name="embed" />
    </a>

  </div>
</template>

<script>
export default {
  name: 'ShareItems',

  computed: {
    window () { return this.$store.state.window },
    data () { return this.$store.state.share.data },

    title () {
      const title = this.data.title ? `: ${this.data.title}` : ''
      return `${this.page.attributes.title}${title}`
    },

    /**
     * Build Facebook URL
     * @return {String}
     */
    facebookUrl () {
      let url = 'https://www.facebook.com/sharer.php?'

      const params = [
        `u=${this.global.site.baseUrl}${this.$route.fullPath}`
      ]

      return url + params.join('&')
    },

    /**
     * Build Twitter URL
     * https://dev.twitter.com/web/intents
     * @return {String}
     */
    twitterUrl () {
      let url = 'https://twitter.com/intent/tweet?'

      const params = [
        `text=${this.title}`,
        `via=${this.global.site.twitterHandle}`,
        `url=${this.global.site.baseUrl}${this.$route.fullPath}`
      ]

      return url + params.join('&')
    },

    /**
     * Build Vimeo URL
     * @return {String}
     */
    vimeoUrl () {
      return `https://vimeo.com/${this.data.vimeoId}`
    },

    /**
     * Build Vimeo embed URL
     * @return {String}
     */
    vimeoEmbedUrl () {
      return `https://vimeo.com/${this.data.vimeoId}#embed`
    },

    /**
     * Build email URL
     * - Shares the current page as email
     * @return {String}
     */
    emailUrl () {
      if (!this.page.attributes) return

      let url = 'mailto:?'

      const body = this.data.description || this.page.attributes.description || this.page.attributes.excerpt || ''

      const params = [
        `subject=${this.title}`,
        `body=${body}%0D%0A%0D%0A${this.global.site.baseUrl}${this.$route.fullPath}`
      ]

      return url + params.join('&')
    }
  },

  methods: {
    /**
     * Open a share service
     * @param  {String} service
     */
    open (service) {
      switch (service) {
        case 'facebook':
          this.openFacebookDialog()
          break
        case 'twitter':
          this.openTwitterDialog()
          break
      }
    },

    /**
     * Open the Facebook share dialog
     */
    openFacebookDialog () {
      window.open(this.facebookUrl, '', 'width=626,height=436')
    },

    /**
     * Open the Twitter share dialog
     * https://dev.twitter.com/web/intents
     */
    openTwitterDialog () {
      window.open(this.twitterUrl, '', 'width=550,height=420')
    }
  }
}
</script>

<style>
@import 'properties';

.ShareItems-item {
  display: block;
}

.ShareItem-icon {
  width: 42px !important;
  height: 42px !important;
}

.ShareItem-icon svg {
  fill: var(--c-white) !important;
}

.ShareItems-item:hover .ShareItem-icon svg {
  fill: var(--c-black) !important;
}
</style>



// WEBPACK FOOTER //
// ShareItems.vue?659d65ee